module.exports = __webpack_public_path__ + "static/media/platformFeatures2.7f74ff2f.png";